import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";
import logo from "../../../assets/website_logo.png";
import "./Footer.css";
import { Phone, Email } from "@mui/icons-material";
import { CONTACT_INFO } from "consts";
import FotterContactForm from "components/FotterContactForm";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  // Don't show form on these routes
  const hideForm = ["/tarifs", "/contact"].includes(location.pathname);

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo + Copyright */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            order: isMobile ? 3 : 1,
          }}
        >
          <div className="footer-logo">
            <Link to="/">
              <img
                src={logo}
                alt="La Maison Des Sons Logo"
                style={{
                  height: "auto",
                  width: isMobile ? "150px" : "100px",
                }}
              />
            </Link>
          </div>

          <div className="footer-copyright">
            <Link to="/" className="site-link">
              Tourbus | LMDS
            </Link>
            <span className="copyright-text">
              © {new Date().getFullYear()} Tous droits réservés
            </span>
          </div>
        </div>

        {/* Contact Form (conditionally hidden) */}
        {!hideForm && (
          <div style={{ order: isMobile ? 1 : 2 }}>
            <FotterContactForm />
          </div>
        )}

        {/* Contact Info */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            order: isMobile ? 2 : 3,
          }}
        >
          <div className="info-item">
            <div
              className="info-content"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
                marginRight: "10px",
                justifyContent: "center",
              }}
            >
              <Email className="info-icon" />
              <h2 style={{ margin: 0 }}>E-MAIL</h2>
              <p>
                <a
                  href={`mailto:${CONTACT_INFO.email}`}
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  {CONTACT_INFO.email}
                </a>
              </p>
            </div>
          </div>

          <div className="info-item">
            <div
              className="info-content"
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "10px",
                marginRight: "10px",
                justifyContent: "center",
              }}
            >
              <Phone className="info-icon" />
              <h2 style={{ margin: 0 }}>Téléphone</h2>
              <p>
                <a
                  href={`tel:+33628124774`}
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  06 28 12 47 74
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
